export default {
  apiKey: "AIzaSyAlqVddwrxQU9V2-_IBYKN3QUzhSGa0-9M",
  authDomain: "wirfuerschule-2020.firebaseapp.com",
  databaseURL: "https://wirfuerschule-2020.firebaseio.com",
  projectId: "wirfuerschule-2020",
  storageBucket: "wirfuerschule-2020.appspot.com",
  messagingSenderId: "631740765553",
  appId: "1:631740765553:web:d5713d96376219733352d0"
}